import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tech-loadingcustodian',
  templateUrl: './loadingcustodian.component.html',
  styleUrls: ['./loadingcustodian.component.scss'],
})
export class LoadingcustodianComponent implements OnInit {
  public logoUrl =
    './assets/img/' +
    localStorage.getItem('ThemeImg') +
    '/WealthRules-265px.png';

  constructor() {}

  ngOnInit(): void {}
}
